import useReturned from "./useReturned";
import { Returned } from "../../../components/correspondence-module/correspondence/returned";

function ReturnedScreen() {
  const { correspondenceFilter } = useReturned();

  return <Returned correspondence={correspondenceFilter} />;
}

export default ReturnedScreen;
